/**
 * Modal overlay which can load content dynamically by supplying it with an
 * options object
 * {
 *  url: source to retrieve
 *  element: element to retrieve from the source
 * }
 */

 const ContentLoader = require('../modules/module-content-loader')

 module.exports = function (app) {
   app.registerComponent('overlay', '.js-overlay', function (sb, el) {
     let contentLoader = new ContentLoader()
     var overlayCloseEl = el.querySelector('.js-overlay-close');
     let modal = el.querySelector('.js-modal')
    //  let modalCloseEl = el.querySelector('.js-modal-close')
      let modalInnerEl = el.querySelector('.js-overlay-content')
      let overlayInnerEl = el.querySelector('.js-overlay-inner');
     let currentModalType
     let onShow = function (data) {
       onShowLoader();
      modalInnerEl.style.height = '0px'
       // empty the overlay
      emptyOverlay()
       //
       if (!data.contentUrl) return false
       document.body.classList.add('overlay-visible')

       //el.classList.add('is-loading')
       contentLoader.loadElement({ element: '.js-content', url: data.contentUrl}, onContentLoaded)
     }

     let calculateInnerHeight = function () {
       var height = modalInnerEl.scrollHeight

       return height
     }

     let setModalHeight = function (height, callback) {
       // modal.style.height = height + 'px'
       modalInnerEl.style.height = height + 'px'
     }

      let updateHeight = function() {
        let newModalHeight = calculateInnerHeight()
       setModalHeight(newModalHeight)
      }
     let onContentLoaded = function (err, result) {
       if (err) {
         el.classList.remove('is-loading')
         return false
       }
       modalInnerEl.appendChild(result.children[0])
      updateHeight();
 

       setTimeout(function () {
         el.classList.remove('is-loading')
       }, 400)

       // added a little timeout to give the dom some
       // time to setup before activating the elements
       setTimeout(function () {
         sb.initializeComponents(modalInnerEl)
         // enable picturefill for ie
       }, 200)

     }

     /**
      * Clear the overlay
      * @return {[type]} [description]
      */
     let emptyOverlay = function () {
       onScrollTop()
       modalInnerEl.innerHTML = ''

                sb.deInitializeElementComponents(modalInnerEl);

     }

     let closeOverlay = function (ev) {
       if (ev) ev.preventDefault()
       
      //setTimeout(function() {
       contentLoader.cancel()
       document.body.classList.remove('overlay-visible')
      //}, 0)

      setTimeout(emptyOverlay, 400);
      
     }


     let onShowLoader = function() {
         el.classList.add('is-loading')


     }
     let onHideLoader = function() {
         el.classList.remove('is-loading')

     }

     let onScrollTop = function() {

       overlayInnerEl.scrollTop = '0px';

       
     }

     sb.subscribe('overlay/show', onShow)
     sb.subscribe('overlay/hide', closeOverlay)
     sb.subscribe('overlay/show_loader', onShowLoader)
     sb.subscribe('overlay/hide_loader', onHideLoader)
     sb.subscribe('overlay/scrolltop', onScrollTop)
     sb.subscribe('overlay/update_height', updateHeight)
     sb.subscribe('window/resize', updateHeight)
     
     
     //el.addEventListener('scroll', onScroll)

    /* INIT ------------------------------------------- */
     return {
       init: function () {
        overlayCloseEl.addEventListener('click', closeOverlay)
       },
       destroy: function () {
        overlayCloseEl.removeEventListener('click', closeOverlay)
      
        sb.unsubscribe('overlay/show', onShow)
        sb.unsubscribe('overlay/hide', closeOverlay)
        sb.unsubscribe('overlay/show_loader', onShowLoader)
        sb.unsubscribe('overlay/hide_loader', onHideLoader)
        sb.unsubscribe('overlay/scrolltop', onScrollTop)
        sb.unsubscribe('overlay/update_height', updateHeight)
        sb.unsubscribe('window/resize', updateHeight)
       }
     }
   })
 }




/*
module.exports = function (app) {
  app.registerComponent('welcome-overlay', '.js-welcome-overlay', function (sb, el) {

    var hideOverlayEl = el.querySelector('.js-hide-overlay');
    var overlayVisible = true;

    var hideOverlay = function() {
      el.classList.remove('is-visible')
            overlayVisible = false;
    }
    var onWindowScroll = function(scroll) {
      if(scroll.scrollPos > 20) hideOverlay()
    }

    /* INIT ------------------------------------------- */
   /* return {
      init: function () {
        console.log(hideOverlayEl)
        sb.subscribe('window/scroll', onWindowScroll)
        hideOverlayEl.addEventListener('click', hideOverlay)
      },
      destroy: function () {
        console.log('Hello World de-initialized')
      }
    }
  })
}*/



// WEBPACK FOOTER //
// ./assets/js/components/overlay.js